import React, {memo} from 'react'
import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'

import {ReactComponent as HotIcon} from '../assets/images/icons/hot-benefit.svg'
import {ReactComponent as EditIcon} from '../assets/images/icons/edit-benefit.svg'
import {ReactComponent as ChartIcon} from '../assets/images/icons/chart-benefit.svg'
import {ReactComponent as AccessibilityIcon} from '../assets/images/icons/accessibility-benefit.svg'
import {ReactComponent as VibrateIcon} from '../assets/images/icons/vibrate-benefit.svg'
import ScrollAnimation from './ScrollAnimation'
import './Benefits.scss'

const benefits = [
  {
    id: 1,
    title: 'stunning design',
    Icon: HotIcon,
    text: 'Our goal is to design beautiful, simple, and intuitive interface that reflect the vision of your business.',
  },
  {
    id: 2,
    title: 'seo-friendly',
    Icon: ChartIcon,
    text: 'The website has all the required elements in place that help the search engines rank it high.',
  },
  {
    id: 3,
    title: 'fully responsive',
    Icon: VibrateIcon,
    text: 'We make sure that the website renders well on a variety of devices and screen sizes.',
  },
  {
    id: 4,
    title: 'editable anytime',
    Icon: EditIcon,
    text: 'All the content of the website can be editable anytime without any technical knowledge. ',
  },

  {
    id: 5,
    title: 'entirely accessible',
    Icon: AccessibilityIcon,
    text: 'There are no barriers that prevent access to the website by people with disabilities.',
  },
]

const renderBenefits = benefits =>
  benefits.map(benefit => (
    <li key={benefit.id} className="Benefits-Item">
      <h3 className="Benefits-ItemTitle">
        <benefit.Icon className="Benefits-ItemIcon" />
        {benefit.title}
      </h3>
      <p className="Benefits-ItemText">{benefit.text}</p>
    </li>
  ))

Benefits.propTypes = {
  width: PropTypes.string.isRequired,
}

function Benefits({width}) {
  return (
    <ScrollableAnchor id="benefits">
      <section className="Benefits">
        <div className="Benefits-Container Container">
          <ScrollAnimation tag="h2" className="Benefits-Title Title" effect="fadeInTop">
            Benefits
          </ScrollAnimation>
          <ScrollAnimation tag="p" className="Benefits-Attention" effect="fadeIn">
            {width !== 'xs' && width !== 'sm' && width !== 'md' ? <b>be ahead of your competitors</b> : <b>be ahead <br /> of your competitors</b>}
          </ScrollAnimation>
          {width !== 'xs' && width !== 'sm' ? (
            <Grid container spacing={2}>
              <Hidden mdDown>
                <Grid item xs={1} />
              </Hidden>
              <Grid item xs={12} md={3} lg={2}>
                <ScrollAnimation tag="ul" className="Benefits-List" effect="fadeInLeft">
                  {renderBenefits(benefits.slice(0, 3))}
                </ScrollAnimation>
              </Grid>
              <Grid item xs={6} />
              <Grid item md={3} lg={2}>
                <ScrollAnimation tag="ul" className="Benefits-List Benefits-List_second" effect="fadeInRight">
                  {renderBenefits(benefits.slice(3))}
                </ScrollAnimation>
              </Grid>
              <Hidden mdDown>
                <Grid item xs={1} />
              </Hidden>
            </Grid>
          ) : (
            <div className="Benefits-Content">
              <div className="Benefits-Block">
                <ScrollAnimation tag="ul" className="Benefits-List" effect="fadeInBottomSmall">
                  {renderBenefits(benefits)}
                </ScrollAnimation>
              </div>
              <div className="Benefits-Block" />
            </div>
          )}
        </div>
      </section>
    </ScrollableAnchor>
  )
}

export default memo(Benefits)
